import Errors from "../../../../shared/errors";
import {
  OnboardingStep1ClassName
} from "./ducks/reducer";

import Onboarding from '../../../../shared/onboarding/onboarding';
import FilmanizeDropZone from '../../../../shared/filmanize-dropzone';
import './shot-row-issues.scss';

export const Upload = (props) => {
  const {
    errors,
    warnings,
    shotsOnboardingSteps,
    uploadShots,
    isUploading,
    missingHeaders,
    unexpectedHeaders,
    shotRowIssues
  } = props;

  const readOnly = false;
  return (
    <div>
      {errors && <Errors errors={errors} />}
      {warnings && <Errors errors={warnings} isWarning={true} />}

      {missingHeaders && missingHeaders.length > 0 &&
        <div className="notification is-warning">
          <h3 className="title is-6">Missing Headers</h3>
          <ul>
            {missingHeaders.map(header => <li key={header}>{header}</li>)}
          </ul>
        </div>}

      {unexpectedHeaders && unexpectedHeaders.length > 0 &&
        <div className="notification is-warning">
          <h3 className="title is-6">Unexpected Headers</h3>
          <ul>
            {unexpectedHeaders.map(header => <li key={header}>{header}</li>)}
          </ul>
        </div>}

      {shotRowIssues && shotRowIssues.length > 0 &&
        <div className="shot-row-issues-container">
          {shotRowIssues.some(issue => issue.hasErrors) ? (
            <div className="notification is-danger">
              <p><strong>File did not get uploaded.</strong> All errors listed below need to be fixed before the file can be uploaded.</p>
            </div>
          ) : (
            <div className="notification is-warning">
              <p><strong>Shots have been uploaded despite warnings.</strong> If you fix the warnings below and upload again, the shots will be updated with the fixes.</p>
            </div>
          )}
          <h3 className="title is-6">Row Issues</h3>
          {(() => {
            const hasErrors = shotRowIssues.some(issue => issue.errors && issue.errors.length > 0);
            const hasWarnings = shotRowIssues.some(issue => issue.warnings && issue.warnings.length > 0);
            return (
              <table className="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Scene</th>
                    <th>Shot</th>
                    {hasErrors && <th>Errors</th>}
                    {hasWarnings && <th>Warnings</th>}
                  </tr>
                </thead>
                <tbody>
                  {shotRowIssues.map((issue, index) => (
                    <tr key={index}>
                      <td>{issue.sceneNumber}</td>
                      <td>{issue.shotNumber}</td>
                      {hasErrors && (
                        <td>
                          {issue.errors && issue.errors.length > 0 && (
                            <ul className="issues-list">
                              {issue.errors.map((error, i) => (
                                <li key={i} className="error-item">{error}</li>
                              ))}
                            </ul>
                          )}
                        </td>
                      )}
                      {hasWarnings && (
                        <td>
                          {issue.warnings && issue.warnings.length > 0 && (
                            <ul className="issues-list">
                              {issue.warnings.map((warning, i) => (
                                <li key={i} className="warning-item">{warning}</li>
                              ))}
                            </ul>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}
        </div>}

      <FilmanizeDropZone
        onboardingClassName={OnboardingStep1ClassName}
        acceptedFileTypes={[".csv", ".xlsx"]}
        upload={uploadShots}
        readOnly={readOnly}
        isUploading={isUploading}
      />
      <Onboarding onboardingSteps={shotsOnboardingSteps} section="Shots Upload" />
    </div>
  );
}